import { connect } from 'react-redux'
import AssignmentRow from '../../../components/employer/assignments/assignmentRows.component'
import {
  getAssignmentById,
  deleteAssignment,
  copyAssignment,
  pinAssignment
} from '../../../actions/employer'
import { convertDataToDict } from '../../../utils/employer/showIndustry.utils'

const mapStateToProps = (state) => {
  const areaOfWorkDict = convertDataToDict(state.assignments.areaOfWork)
  return {
    state,
    areaOfWorkDict: areaOfWorkDict,
    employerContractList: state.assignments.employerContractList,
    showSnackbarAdd: state.assignments.showSnackbarAdd,
    showSnackbarUpdate: state.assignments.showSnackbarUpdate,
    companyProfile: state.companyProfile.userData
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getAssignmentById: (id) => dispatch(getAssignmentById(id)),
    deleteAssignment: (id) => dispatch(deleteAssignment(id)),
    copyAssignment: (id) => dispatch(copyAssignment(id)),
    pinAssignment: (assignment_id) => dispatch(pinAssignment(assignment_id))
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const AssignmentRowContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AssignmentRow)

export default AssignmentRowContainer
